"use client";
import { useCallback, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import { Swiper as SwiperType } from "swiper";
import {
  SpecialFilterItem,
  SelectedFilters,
} from "@/app/lib/features/filters/filters.types";

interface SpecialFiltersSwiperProps {
  specialFilters: SpecialFilterItem[];
  selected: SelectedFilters;
  toggleSpecial: (key: string) => void;
}

const SpecialFiltersSwiper = ({
  specialFilters,
  selected,
  toggleSpecial,
}: SpecialFiltersSwiperProps) => {
  const [showLeftGradient, setShowLeftGradient] = useState(false);
  const [showRightGradient, setShowRightGradient] = useState(true);

  const updateGradients = useCallback((swiper: SwiperType) => {
    setShowLeftGradient(!swiper.isBeginning);
    setShowRightGradient(!swiper.isEnd);
  }, []);

  return (
    <div className="relative">
      <Swiper
        spaceBetween={8}
        freeMode={{
          enabled: true,
          momentumRatio: 0.25,
          momentumVelocityRatio: 0.25,
        }}
        onSwiper={updateGradients}
        onSlideChange={updateGradients}
        onProgress={updateGradients}
        onTouchEnd={(s) => setTimeout(() => updateGradients(s), 50)}
        onTransitionEnd={updateGradients}
        modules={[FreeMode]}
        slidesPerView="auto"
      >
        {specialFilters.map((filter) => {
          const isActive =
            filter.key === "all"
              ? selected.special_filters.length === 0
              : selected.special_filters.includes(filter.key);
          return (
            <SwiperSlide key={filter.key} className="w-auto!">
              <button
                onClick={() => toggleSpecial(filter.key)}
                className={`flex items-center gap-1.5 py-1.5 px-3 rounded-full border text-sm whitespace-nowrap transition-all duration-200 ${
                  isActive
                    ? "border-gray-800 bg-gray-50 ring-1 ring-gray-300 font-medium"
                    : "border-gray-200 bg-white hover:border-gray-400"
                }`}
              >
                <span>{filter.icon}</span>
                <span className="text-gray-700">{filter.label}</span>
              </button>
            </SwiperSlide>
          );
        })}
        <div
          className={`absolute top-0 left-0 z-20 w-5 sm:w-8 h-full bg-linear-to-r from-white to-transparent transition-opacity duration-300 pointer-events-none ${showLeftGradient ? "opacity-100" : "opacity-0"}`}
        />
        <div
          className={`absolute top-0 right-0 z-20 w-5 sm:w-8 h-full bg-linear-to-l from-white to-transparent transition-opacity duration-300 pointer-events-none ${showRightGradient ? "opacity-100" : "opacity-0"}`}
        />
      </Swiper>
    </div>
  );
};

export default SpecialFiltersSwiper;
